import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { TrashIcon } from '../../../../design/static/icons/TrashIcon';
import { useAttachmentsPermissions } from '../../../../modules/attachments/Attachments.permissions';
import { EnableFor } from '../../../containers/EnableForRole';
import { useAttachmentsService } from '../attachments.service';

export const AttachmentDeleteContainer = observer((): ReactElement => {
  const attachmentsService = useAttachmentsService();
  const { t } = useTranslator();
  const permissions = useAttachmentsPermissions();

  const onDelete = (): void => {
    attachmentsService.toggleDeleteAttachmentModal();
  };

  const isDisabled =
    !attachmentsService.store.attachments.length ||
    (!attachmentsService.store.selectedAttachments.isAllSelected &&
      attachmentsService.store.selectedAttachments.ids &&
      !attachmentsService.store.selectedAttachments.ids.length);

  return (
    <EnableFor hasPermission={permissions.canDeleteAttachments()}>
      <Button
        variant='outlined'
        onClick={onDelete}
        disabled={isDisabled}
        startDecorator={<TrashIcon />}
      >
        {t('delete_attachments')}
      </Button>
    </EnableFor>
  );
});
